// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2onJG","title":"styles_title__2nStY","image":"styles_image__3dO-u","buttons":"styles_buttons__3jqWh"};